import { PipeTransform } from '@angular/core';
import { Tenant } from '../types/tenant';

export class TenantSelectorTransform implements PipeTransform {
	transform(value: Tenant, ...args: any[]): any {
		return `${value.tenantId} - ${value.label} `;
	}
}
